<template>
  <div class="partner-v3">
    <Heading
      tag="h2"
      align="center"
      size="sm"
      spaces-bottom
    >
      <template v-if="useFormal">
        Auch bei diesen Partnern können Sie bequem per Handyrechnung bezahlen per Handyrechnung
        zahlen und Ihre Gutschrift einlösen.
      </template>
      <template v-else>
        Wenn dir das noch nicht reicht, dann sind vielleicht unsere Partner etwas für dich. Auch
        hier kannst du bequem per Handyrechnung bezahlen.
      </template>
    </Heading>

    <div class="partner-v3__usps">
      <DraggableScroller
        class="partner-v3__scroller"
        has-pagination
        hide-pagination-mobile
        show-single-active-pagination
        :autoplay-time="6000"
        :autoplay-elements="1"
        :tabindex="0"
      >
        <div
          v-for="(entry, key) in list"
          :key="key"
          class="partner-v3__entries"
          :class="`partner-v3__entries--${key}`"
        >
          <Card v-bind="entry" />
        </div>
      </DraggableScroller>
      * bei Neuabschluss
    </div>
  </div>
</template>

<script setup lang="ts">
import { Card, detectDevice, Heading } from '@i22team/td-longtail-vue-components';
import DraggableScroller from '~/components/draggable-scroller.vue';
import type { CardComponentProps } from '@i22team/td-longtail-vue-components';

withDefaults(defineProps<{ useFormal?: boolean }>(), {
  useFormal: false,
});

const DEFAULTS: CardComponentProps = {
  size: 'small',
};

const list = reactive<CardComponentProps[]>([
  {
    ...DEFAULTS,
    image: {
      src: '/content/content-images/dcb/november/16013acdd7146af6fbc6a46cb5b90d32/map_outline.svg',
      aspectRatio: '24 / 25',
      lazy: true,
    },
    heading: {
      tag: 'h3',
      size: 'sm',
      text: 'PayByPhone',
    },
    buttons: [
      {
        tag: 'a',
        target: '_blank',
        isWide: true,
        secondary: true,
        label: 'Zur App',
        href: 'https://www.paybyphone.de/standorte',
      },
    ],
  },
  {
    ...DEFAULTS,
    image: {
      src: '/content/content-images/dcb/november/e51a16fe98f2ea9073b15ca982eb7e90/e-mobility_outline.svg',
      aspectRatio: '24 / 25',
      lazy: true,
    },
    heading: {
      tag: 'h3',
      size: 'sm',
      text: 'MOOVILITY',
    },
    buttons: [
      {
        tag: 'a',
        target: '_blank',
        isWide: true,
        secondary: true,
        label: 'Zur App',
        href: 'https://actions.cirrantic.com/de/de-de/wallet-special-zahl-einfach-per-handyrechnung',
      },
    ],
  },
  {
    ...DEFAULTS,
    image: {
      src: '/content/content-images/dcb/november/e5a483ec8992885b304caa0895a1fe2c/video-clip_outline.svg',
      aspectRatio: '24 / 25',
      lazy: true,
    },
    heading: {
      tag: 'h3',
      size: 'sm',
      text: 'Netflix*',
    },
    buttons: [
      {
        tag: 'a',
        target: '_blank',
        isWide: true,
        secondary: true,
        label: 'Zum Anbieter',
        href: 'https://www.netflix.com/de/',
      },
    ],
  },
  {
    ...DEFAULTS,
    image: {
      src: '/content/content-images/dcb/november/8c7b9fd8cc3b603afc1bd5f3e924979c/game-controller_outline.svg',
      aspectRatio: '24 / 25',
      lazy: true,
    },
    heading: {
      tag: 'h3',
      size: 'sm',
      text: 'PlayStation Store',
    },
    buttons: [
      {
        tag: 'a',
        target: '_blank',
        isWide: true,
        secondary: true,
        label: 'Zum Anbieter',
        href: 'https://store.playstation.com/de-de/',
      },
    ],
  },
]);

onMounted(() => {
  list.forEach((entry) => {
    if (!entry?.buttons) return;
    if (entry.heading?.text === 'MOOVILITY') {
      if (detectDevice.device.value === 'iOS') {
        entry.buttons[0].href = 'https://apps.apple.com/de/app/moovility/id1216213899';
      }
      if (detectDevice.device.value === 'Android') {
        entry.buttons[0].href =
          'https://play.google.com/store/apps/details?id=com.cirrantic.moovilityapp';
      }
    }

    if (entry.heading?.text === 'PayByPhone') {
      if (detectDevice.device.value === 'iOS') {
        entry.buttons[0].href =
          'https://apps.apple.com/de/app/paybyphone-parken-per-app/id448474183';
      }
      if (detectDevice.device.value === 'Android') {
        entry.buttons[0].href = 'https://play.google.com/store/apps/details?id=com.paybyphone';
      }
    }
  });
});
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.partner-v3 {
  position: relative;
  margin-bottom: $grid-base * 5;
  text-align: center;

  @include mq($mq-md) {
    margin-bottom: $grid-base * 8;
  }

  &__entries {
    margin: $grid-base;
  }

  &__scroller {
    :deep(.draggable-scroller__container) {
      display: flex;
      width: 100%;
      align-items: stretch;

      > * {
        flex: 0 0 calc(100% - $grid-base * 2);
        @include mq($mq-sm) {
          flex: 0 0 calc(50% - $grid-base * 2);
        }
        @include mq($mq-md) {
          flex: 0 0 calc(25% - $grid-base * 2);
        }
      }
    }
  }
}
</style>
